import AdListView from "@/views/admin/ads/AdListView";
import AdAnalyticsView from "@/views/admin/ads/AdAnalyticsView";

export default [
  {
    name: "pages.admin.ads",
    path: "ads",
    component: AdListView
  },
  {
    name: "pages.admin.ads.analytics",
    path: "ads/analytics",
    component: AdAnalyticsView
  }
  
];
